<template>
  <div class="py-1">
    <MenuOption
      id="view-shipments"
      :title="$t('area.dhl.settings.action.view-shipments')"
      @select="onViewShipmentsSelect">
      <template #icon>
        <IconLucideTruck class="h-4 w-4" />
      </template>
    </MenuOption>
    <!-- DEV: opens a modal to connect DHL using one of the sandbox test accounts —
         never shown outside dev tooling, see _Assets/DHL/Sandbox Test Credentials.md -->
    <MenuOption
      v-if="isDeveloper && showDevActions"
      id="connect-sandbox"
      :title="$t('area.dhl.settings.action.connect-sandbox-dev')"
      @select="onConnectSandboxSelect">
      <template #icon>
        <div class="flex items-center gap-1.5">
          <DevBadge />
          <IconLucideSparkles class="h-4 w-4" />
        </div>
      </template>
    </MenuOption>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { useUserStore } from '@/stores/userStore'
import { mapState } from 'pinia'

export default {
  name: 'DhlSettingsMenu',

  emits: ['close'],

  props: {
    onOpenShipments: { type: Function as PropType<() => void>, required: true },
    onConnectSandbox: { type: Function as PropType<() => void>, required: true },
  },

  computed: {
    ...mapState(useUserStore, ['isDeveloper', 'showDevActions']),
  },

  methods: {
    onViewShipmentsSelect(): void {
      this.onOpenShipments()
      this.$emit('close')
    },

    onConnectSandboxSelect(): void {
      this.onConnectSandbox()
      this.$emit('close')
    },
  },
}
</script>
